export default "__VITE_ASSET__KrlXk7bN__"